export const lockScroll = () => {
    const scrollY = window.scrollY;
    document.body.classList.add("modal-open");
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${scrollY}px`;
  
    return scrollY; // Save scroll position
  };
  
  export const unlockScroll = (scrollY) => {
    document.body.classList.remove("modal-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
  
    // Restore scroll position instantly
    window.scrollTo({ top: scrollY, behavior: "instant" });
  };
  